import React from 'react';
import { useTranslation } from 'react-i18next';
import Information, { InformationType } from '../../../../components/envago/Information/Information';
import { ImportGroup } from '../ImportExcel.types';
import { countPlausibleGroupRows } from '../ImportExcel.utils';

type Props = {
  groups: ImportGroup[];
  totalRows: number;
};

export const PlausibleStep: React.FC<Props> = ({ groups, totalRows }) => {
  const { t } = useTranslation();

  const plausibleCount = countPlausibleGroupRows(groups);
  // Everything else (implausible, not_found, no_value, partial, duplicates, ...)
  // is broken down with exact counts in the Summary step — this screen only
  // needs to announce the newly detected plausible readings and how many
  // remaining rows are still being handled in the next steps.
  const remainingCount = Math.max(totalRows - plausibleCount, 0);

  return (
    <div className="flex flex-col gap-4">
      <Information type={InformationType.SUCCESS}>
        {t('management.import.plausible.body', { count: plausibleCount })}
      </Information>

      {remainingCount > 0 && (
        <p className="text-sm text-gray-500">
          {t('management.import.plausible.otherSkipped', { count: remainingCount })}
        </p>
      )}
    </div>
  );
};
